import React, { useEffect } from "react";
import Script from "next/script";
import Layout from "components/Layout";
import { BackHeader } from "@xt/Nav";
import { get_tdk } from "api/server/tdk";
import { Context, Util, Hooks, Platform } from "@xt/xtbase";
import { useRouter } from "next/router";
import Banner from "@/components/Pages/referral/banner";
import Content from "@/components/Pages/referral/content";
import { preloadReferralPosterImages } from "utils/referralPosterUrl";
import { preloadCanvasSafePosterImages } from "utils/captureSharePoster";

const {getOrigin} = Util;
const {XtContext} = Context;
const {useTranslation} = Hooks;

export default function PageIndex(props) {
  const [appState] = React.useContext(XtContext);
  const { lang } = appState;
  const router = useRouter();
  const t = useTranslation();

  const handleBack = () => {
    router.back();
  };

  useEffect(() => {
    preloadReferralPosterImages();
    preloadCanvasSafePosterImages();
  }, []);
  return (
    <>
      <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
        <BackHeader title={t("home.invitees") || "Referrals"} onBack={handleBack} />
        <div style={{ paddingTop: Platform.isInApp() ? "env(safe-area-inset-top, 0px)" : "calc(44px + env(safe-area-inset-top, 0px))" }}>
          <Banner enableReferralV2Ui>
            <Content showLoggedInReferralMain={false} />
          </Banner>
        </div>
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "/referral";
  const props = {resolvedUrl,theme:"dark"};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}
